import React, { useState } from "react";
import { Box, Typography, Grid, Modal, Card, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const AllImagesModal = ({ open, onClose, images }) => {
  const [slideshowOpen, setSlideshowOpen] = useState(false);
  const [slideshowIndex, setSlideshowIndex] = useState(0);

  const handleImageClick = (idx) => {
    setSlideshowIndex(idx);
    setSlideshowOpen(true);
  };

  const handlePrev = () => {
    setSlideshowIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setSlideshowIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      {/* Main Modal for all images */}
      <Modal
        open={open}
        onClose={onClose}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Card
          sx={{
            width: { xs: "98vw", sm: "90vw", md: "70vw" },
            maxHeight: "90vh",
            overflowY: "auto",
            outline: "none",
            borderRadius: 3,
            p: 3,
            background: "#fff",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 3,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontFamily: "Monument-Private",
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              All Photos
            </Typography>
            <IconButton onClick={onClose} sx={{ ml: 2 }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Grid container spacing={2}>
            {images.map((img, idx) => {
              // Pattern: 1st image spans 2 cols, next 2 are 1 col each, repeat
              let gridProps = {};
              if (idx % 3 === 0) {
                gridProps = { xs: 12, sm: 12, md: 12 };
              } else {
                gridProps = { xs: 6, sm: 6, md: 6 };
              }
              return (
                <Grid item key={img} size={{ ...gridProps }}>
                  <Box
                    component="img"
                    src={img}
                    alt={`Property image ${idx + 1}`}
                    sx={{
                      width: "100%",
                      objectFit: "cover",
                      borderRadius: 2,
                      boxShadow: 1,
                      cursor: "pointer",
                    }}
                    onClick={() => handleImageClick(idx)}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Card>
      </Modal>

      {/* Slideshow Modal */}
      <Modal
        open={slideshowOpen}
        onClose={() => setSlideshowOpen(false)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1400,
        }}
      >
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.95)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <IconButton
            onClick={() => setSlideshowOpen(false)}
            sx={{
              position: "absolute",
              top: 24,
              right: 24,
              color: "white",
              zIndex: 2,
            }}
          >
            <CloseIcon />
          </IconButton>
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: 24,
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
              background: "rgba(0,0,0,0.3)",
              "&:hover": { background: "rgba(0,0,0,0.5)" },
              zIndex: 2,
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
          <Box
            component="img"
            src={images[slideshowIndex]}
            alt={`Slideshow image ${slideshowIndex + 1}`}
            sx={{
              maxWidth: "90vw",
              maxHeight: "80vh",
              borderRadius: 2,
              boxShadow: 3,
              objectFit: "contain",
            }}
          />
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: 24,
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
              background: "rgba(0,0,0,0.3)",
              "&:hover": { background: "rgba(0,0,0,0.5)" },
              zIndex: 2,
            }}
          >
            <ChevronRightIcon />
          </IconButton>
        </Box>
      </Modal>
    </>
  );
};

export default AllImagesModal;
